import { Component, forwardRef, Input, OnInit } from '@angular/core'
import {
  ControlValueAccessor,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  PatternValidator,
  Validators
} from '@angular/forms'
import { CatalogueService } from '../../../../services/catalogue.service'
import { Address } from '../../../../models/address'
import { SelectItem } from 'primeng/api'
import { Field } from '../../models/field'
import { skip } from 'rxjs/operators'

@Component({
  selector: 'jml-lib-address-control',
  templateUrl: './address-control.component.html',
  styleUrls: ['./address-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AddressControlComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: AddressControlComponent,
      multi: true
    }
  ]
})
export class AddressControlComponent implements OnInit, ControlValueAccessor {
  @Input() field: Field
  @Input() required: boolean
  @Input() control: FormGroup | undefined
  @Input() header: string | undefined
  @Input() autoSelect = false

  addressForm = new FormGroup({
    streetName: new FormControl(''),
    houseNumber: new FormControl(''),
    zipCode: new FormControl(''),
    city: new FormControl(''),
    countryId: new FormControl(),
    repr: new FormControl()
  })
  formValidCustom: any = false
  onTouched = (obj) => {}
  onChange = (obj) => {}

  countries: SelectItem[] = []

  constructor(private catalogueService: CatalogueService) {}

  writeValue(obj: any): void {
    if (!obj) this.addressForm.reset()
    else {
      this.addressForm.patchValue(obj)
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.addressForm.disable()
    } else {
      this.addressForm.enable()
    }
  }

  validate({ value }: FormControl) {
    this.formValidCustom = this.addressForm.get('streetName').invalid &&
      this.addressForm.get('houseNumber').invalid &&
      this.addressForm.get('city').invalid &&
      this.addressForm.get('zipCode').invalid &&
      this.addressForm.get('countryId').invalid && { invalid: true }

    return this.formValidCustom
  }

  ngOnInit(): void {
    // Falls ein externes Control übergeben wurde, setze das interne addressForm nicht auf.
    if (this.control) {
      this.addressForm = this.control
    } else {
      const validators = [Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]
      if (this.required) {
        validators.push(Validators.required)
        this.addressForm.get('countryId').setValidators(Validators.required)
      }
      this.addressForm.get('streetName').setValidators(validators)
      this.addressForm.get('houseNumber').setValidators(validators)
      this.addressForm.get('city').setValidators(validators)
      this.addressForm.get('zipCode').setValidators(validators)
    }

    this.catalogueService.getCatalogue('COUNTRIES').subscribe((catalogue) => {
      this.countries = catalogue.values.map((value) => {
        return { label: value['name'], value: value['id'] }
      })
    })

    this.addressForm.statusChanges.subscribe(() => {
      if (this.addressForm.touched) this.onTouched(this.addressForm.value)
    })

    this.addressForm.valueChanges.pipe(skip(2)).subscribe((value) => {
      let address = new Address()
      Object.assign(address, value)
      const item = this.countries.find((country) => country.value === value.countryId)
      if (!!item) {
        address.country = item.label
      }
      this.onChange(address)
    })
  }
}
